/**
 * relation-graph-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class RelationGraphSubjectContextRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_RELATION_GRAPH_SUBJECT_CONTEXT;
  public static tag : MessageTag = MessageTag.REQ_RELATION_GRAPH_SUBJECT_CONTEXT;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }

  constructor (
    public objectId : number,
    public nodeId : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/relation-graph-subject-context-request.ts